import AdProRoutes from "./AdPro.routes";
import { get, patch } from "../index";

const AdProServices = {
  getAllAdPros: async (page, limit, industry, service, status) => {
    console.log("🚀 ~ getAllAdPros: ~ status:", status)
    const result = await get(
      AdProRoutes.getAllAdPros + `?page=${page}&limit=${limit}&service=${service}&industry=${industry}&isContacted=${status == "Pending" ? false : status == "Contacted" ? true : ""}`
    );
    return result;
  },

  downloadFile: async (url) => {
    const result = await get(AdProRoutes.downloadFile + `${url}`);
    return result;
  },

  updateStatus: async (id, obj) => {
    const result = await patch(AdProRoutes.updateStatus + `/${id}`, obj);
    return result;
  }
}

export default AdProServices;